export default __webpack_public_path__ + "static/media/true_sume_v_eng.dcea03c1.png";